import { Button } from "../../components/ui/Button";

export default function CreditCard({ className = "", onGoToRegister }) {
    return (
        <section id="CreditCard" className={"bg-white-50 w-full flex items-center justify-center " + className}>
            <div className="flex flex-col items-center justify-center bg-[#FFFFFF] max-w-5xl w-full">
                <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                    Vantagens
                </span>
                <h2 className="text-center text-2xl font-semibold mb-10">
                    Confira os benefícios em ter os dois cartões:
                </h2>

                <div className="w-full flex flex-col md:flex-row items-center justify-center">
                    {/* Cards and labels */}
                    <div className="flex flex-col gap-6 items-center">
                        <div className="flex flex-col items-center gap-2">
                            <img
                                src="assets/cartoes-bmg-2.png"
                                alt="BMG Payroll Credi1t Card"
                                className="w-full rounded"
                            />
                        </div>
                    </div>

                    {/* Benefits List */}
                    <div className="flex-1">
                        <ul className="space-y-3 text-gray-700">
                            <li>✓ Sem anuidade</li>
                            <li>✓ Desconto em farmácias</li>
                            <li>✓ Compre em lojas físicas e online</li>
                            <li>✓ Saque de até 70% do limite do cartão</li>
                            <li>✓ Dobro do limite. Dobro do valor de saque</li>
                            <li>✓ Seguro de vida com auxílio ou assistência funeral gratuita (INSS)</li>
                            <li>✓ Desconto mínimo da fatura no benefício</li>
                            <li>✓ Programa Mastercard® Surpreenda</li>
                        </ul>
                        <br />
                        <Button onClick={onGoToRegister}>
                            Contratar agora!
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
}
